import { keyframes } from "@emotion/react";

export const dot = keyframes`
  0%, 80%, 100% { opacity: .25; transform: translateY(0); }
  40%           { opacity: 1;   transform: translateY(-3px); }
`;

export const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const pulseRing = keyframes`
  0%   { transform: scale(0.6); opacity: 0.8; }
  100% { transform: scale(1.5); opacity: 0;   }
`;

export const pop = keyframes`
  from        { transform: scale(.6);  opacity: 0; }
  60%         { transform: scale(1.08); }
  to          { transform: scale(1);   opacity: 1; }
`;

export const glowPulse = keyframes`
  0%, 100% { transform: scale(1);    opacity: 0.55; }
  50%      { transform: scale(1.18); opacity: 0.85; }
`;

export const twinkle = keyframes`
  0%, 100% { opacity: 0; transform: scale(0.4); }
  30%, 70% { opacity: 1; transform: scale(1);   }
`;
